import { IoGlobeOutline } from "react-icons/io5";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { MdOutlineContentCopy } from "react-icons/md";
import ChangePassword from "./ChangePassword";
import { BiLogOut } from "react-icons/bi";
import { CiCalendarDate } from "react-icons/ci";
import { toast } from "react-toastify";
import { IoCalendarOutline } from "react-icons/io5";
import { WiTime4 } from "react-icons/wi";
import { useEffect, useMemo } from "react";
function Header({ onLogout, handleCenterChange, centerData, selectedCenter }) {
  const navigate = useNavigate();
  const location = useLocation();
  const userName = localStorage.getItem("userName");
  const LoginUserName = localStorage.getItem("LoginUserName");
  const userEmail = localStorage.getItem("email");
  const storedScreens = useMemo(
    () => JSON.parse(localStorage.getItem("screens") || "{}"),
    [],
  );
  // console.log("Storage storedScreens is ::", storedScreens?.enrollmentForm);

  const handleLogOutClick = () => {
    document.body.classList.remove("offcanvas-backdrop", "modal-open");
    document.body.style.overflow = "auto";
    document.body.style.paddingRight = "0px";
    onLogout();
    navigate("/login");
  };

  // Condition to hide the select dropdown
  const hideCenterSelect =
    location.pathname === "/sms/calendar" ||
    location.pathname === "/calendar" ||
    location.pathname === "/sms/scheduleReport" ||
    location.pathname === "/scheduleReport" ||
    location.pathname === "/lead/lead/add" ||
    location.pathname === "/report/studentReports" ||
    location.pathname === "/report/revenueReports" ||
    location.pathname === "/othermessaging" ||
    location.pathname === "/messaging" ||
    location.pathname === "/report/studentAttendanceReport" ||
    location.pathname === `/lead/lead/edit/:id`;

  const allowAllCenter =
    location.pathname !== "/report/timetableReport" &&
    location.pathname !== "/invoice/add";

  // const ENROLMENT_FORM_URL = "http://localhost:3000/sms/newStudentForm";
  const ENROLMENT_FORM_URL = "https://hrisasia.com/sms/newStudentForm";
  // const ENROLMENT_FORM_URL = "https://artylearning.com/newStudentForm";

  const handleEnrolmentFormCopy = async () => {
    try {
      await navigator.clipboard.writeText(ENROLMENT_FORM_URL);
      toast.success("Enrollment form link copied!");
    } catch (err) {
      toast.error("Failed to copy URL.");
    }
  };

  const handleOpenEnrolmentForm = () => {
    // Close offcanvas if open
    const offcanvasEl = document.getElementById("offcanvasRight");
    if (offcanvasEl) {
      const bsOffcanvas = window.bootstrap?.Offcanvas.getInstance(offcanvasEl);
      if (bsOffcanvas) {
        bsOffcanvas.hide();
      }
    }

    // Navigate after closing
    navigate("/newStudentForm", {
      state: { redirectUrl: "/student" },
    });
  };

  useEffect(() => {
    if (
      !allowAllCenter &&
      centerData &&
      centerData.length > 0 &&
      (selectedCenter === "0" || !selectedCenter)
    ) {
      handleCenterChange({
        target: { value: centerData[0].id },
      });
    }
  }, [allowAllCenter, centerData, selectedCenter]);

  return (
    <nav>
      <div className="d-flex align-items-center justify-content-between pt-2 pb-2 px-2">
        <div className="sidebar-button" style={{ cursor: "pointer" }}>
          <i className="bx bx-menu sidebarBtn"></i>
        </div>

        <div className="d-flex align-items-center justify-content-evenly gap-3">
          {/* Timetable */}
          <Link to={"/report/timetableReport"} className="icon-nav-link">
            <div className="icon-nav-item">
              <button type="button" className="calendar-btn">
                <IoCalendarOutline className="calendar-icon-time" />
                <WiTime4 className="time-icon" />
              </button>
              <span className="icon-nav-label">Timetable</span>
            </div>
          </Link>

          {/* Calendar */}
          <Link to={"/calendar"} className="icon-nav-link">
            <div className="icon-nav-item">
              <button className="btn" type="button">
                <CiCalendarDate
                  style={{
                    color: "#287f71",
                    fontSize: "25px",
                    fontWeight: "bolder",
                  }}
                />
              </button>
              <span className="icon-nav-label">Calendar</span>
            </div>
          </Link>

          <div className="position-relative">
            {!hideCenterSelect && (
              <select
                value={selectedCenter || ""}
                className="form-select shadow-none"
                onChange={handleCenterChange}
                style={{
                  border: "none",
                  outline: "none",
                  fontSize: "14px",
                  width: "auto !important", // ✅ must be a string
                  minWidth: "fit-content !important", // ✅ adjusts to text size
                  maxWidth: "100%",
                }}
              >
                <option value="" disabled>
                  Select a Centre
                </option>

                {allowAllCenter && userName === "SMS_ADMIN" && (
                  <option value="0">All Center</option>
                )}

                {centerData?.map((center) => (
                  <option key={center.id} value={center.id}>
                    {center.centerNames}
                  </option>
                ))}
              </select>
            )}
          </div>
          <button
            className="btn border border-1 rounded-circle"
            type="button"
            data-bs-toggle="offcanvas"
            data-bs-target="#offcanvasRight"
            aria-controls="offcanvasRight"
          >
            <i className="fa fa-user" style={{ color: "#eb862a" }}></i>
          </button>
        </div>
      </div>

      <div
        className="offcanvas offcanvas-end"
        id="offcanvasRight"
        tabIndex="-1"
        aria-labelledby="offcanvasRightLabel"
      >
        <div className="offcanvas-header d-flex justify-content-end">
          <button
            type="button"
            className="btn-close"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
          ></button>
        </div>
        <div className="offcanvas-body d-flex flex-column">
          <div className="flex-grow-1">
            <div className="text-center">
              <h3 className="cname_canvas">Arty Learning</h3>
            </div>
            <div className="text-center mt-3">
              <i
                className="fa-duotone fa-solid fa-user"
                style={{
                  color: "#e99e5e",
                  background: "#fce6cf",
                  borderRadius: "100%",
                  padding: "20px",
                  cursor: "pointer",
                  fontSize: "4rem",
                }}
              ></i>
            </div>
            <div className="d-flex justify-content-center align-items-center">
              <span
                className="w-25 my-2 rounded-2 text-center text-dark fw-bold border-1 border-dark"
                style={{ fontSize: "12px", background: "#cececeb8" }}
              >
                {userName
                  .replace(/^SMS_/, "") // remove SMS_ prefix
                  .toLowerCase()
                  .replace(/\b\w/g, (char) => char.toUpperCase())}{" "}
                {/* Pascal Case */}
              </span>
            </div>

            <div className="list-group list-group-flush my-1 text-center">
              {LoginUserName && (
                <p className="fs-5 fw-medium">AL {LoginUserName}</p>
              )}

              <p className="text-muted small">{userEmail}</p>
            </div>

            <div className="text-center mt-2 d-flex justify-content-center gap-2">
              {storedScreens?.enrollmentForm ? (
                <button
                  className="btn btn-sm btn-border"
                  type="button"
                  onClick={handleEnrolmentFormCopy}
                >
                  <MdOutlineContentCopy className="me-1 fs-6" />
                  Copy Link
                </button>
              ) : (
                <></>
              )}

              <button
                className="btn btn-sm btn-button"
                type="button"
                onClick={handleOpenEnrolmentForm}
              >
                <IoGlobeOutline className="me-1 fs-6" />
                Open Form
              </button>
            </div>
          </div>

          <div className="mt-auto gap-2">
            <div className="row">
              <div
                className="col-md-12 col-12 text-center"
                data-bs-dismiss="offcanvas"
              >
                <ChangePassword />
              </div>
              <div className="col-md-12 col-12 text-center">
                <button
                  className="btn btn-button mt-3 w-75"
                  onClick={handleLogOutClick}
                >
                  <BiLogOut /> Logout
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </nav>
  );
}

export default Header;
